export const INTRO = 'intro';
export const QUESTION = 'question';
export const FEEDBACK = 'feedback';
export const FEEDBACK_CORRECT = 'feedback-correct';
export const FEEDBACK_INCORRECT = 'feedback-incorrect';
export const SYNONYMS = 'synonyms';
export const ANTONYMS = 'antonyms';
export const ANSWERS = 'answers';
export const OPTIONS = 'options';
